var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileyOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/dark-UI/smiley_offline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0002 48 0.0002 48 48 0 48"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/dark-UI/smiley_offline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,22.4072 C30.311,22.4072 28.101,21.0802 27.09,18.8562 L28.91,18.0282 C29.598,19.5402 31.089,20.4072 33,20.4072 C34.903,20.4072 36.286,19.5932 37.11,17.9862 L38.89,18.8982 C37.713,21.1942 35.676,22.4072 33,22.4072 M24.077,40.0002 L23.989,40.0002 C20.147,39.9702 16.264,38.1772 13.854,35.3172 L16.146,33.3842 C17.98,35.5582 21.067,36.9772 24.012,37.0002 L24.075,37.0002 C26.947,37.0002 29.927,35.6132 31.865,33.3702 L34.135,35.3312 C31.606,38.2592 27.852,40.0002 24.077,40.0002 M9.09,18.8562 L10.91,18.0282 C11.598,19.5402 13.089,20.4072 15,20.4072 C16.903,20.4072 18.286,19.5932 19.11,17.9862 L20.89,18.8982 C19.713,21.1942 17.676,22.4072 15,22.4072 C12.311,22.4072 10.101,21.0802 9.09,18.8562 M24,0.0002 C10.745,0.0002 0,10.7452 0,24.0002 C0,37.2552 10.745,48.0002 24,48.0002 C37.255,48.0002 48,37.2552 48,24.0002 C48,10.7452 37.255,0.0002 24,0.0002",
    id: "Fill-1",
    fill: "#9A9B9B",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyOffline);
export default __webpack_public_path__ + "static/media/smileyOffline.5eeb15fe0efebd09fac6b35a543fd470.svg";
export { ForwardRef as ReactComponent };